export default {
  apiEndpoint: "https://adecco-e-learning-cms.stg.finervision.com",
  localStorage: {
    language: "e-learning-language",
    userAnswer: "e-learning-userAnswer",
    languageSelected: "e-learning-languageSelected",
    debriefIndex: "e-learning-debriefIndex"
  },
};

